import { reducerWithInitialState } from "typescript-fsa-reducers";

import * as action from "@stores/v201910/domain/mgr/GroupHome/report/action";
import {
  ReportState,
  Report,
  ReportTypeInterface,
  ReportPerformanceDaily,
  ReportPostDailyState
} from "@stores/v201910/domain/mgr/GroupHome/report/type";

const initialState: ReportState = {
  performanceDaily: {
    before: {
      bodyRestraintAbolitionUnexecutedFlg: false,
      targetDate: ""
    },
    after: {
      bodyRestraintAbolitionUnexecutedFlg: false,
      targetDate: ""
    }
  },
  reportDaily: {
    before: [],
    after: []
  },
  reportMonthly: {
    before: [],
    after: []
  }
};

const stateCreate = (
  state: ReportState,
  stateType: string,
  payload: {
    value: string;
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  const reportState = state;
  reportState[payload.type].after[payload.key][stateType] = payload.value;
  return {
    ...reportState
  };
};

/**
 * statusTypeの変更時にremarks以外を初期化する
 * TODO: use constant
 */
const changeStatusTypeState = (
  state: ReportState,
  payload: {
    value: Report["statusType"];
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  const reportState = state;
  reportState[payload.type].after[payload.key].statusType = payload.value;
  reportState[payload.type].after[payload.key].nightSupportType = "1";
  reportState[payload.type].after[payload.key].nightSupportTargetUsers = "0";
  reportState[payload.type].after[payload.key].hospitalizationSupportType = "1";
  reportState[payload.type].after[payload.key].getHomeSupportType = "1";
  reportState[payload.type].after[payload.key].daytimeSupportType = "1";
  reportState[payload.type].after[payload.key].medicalSupportType = "1";
  reportState[payload.type].after[payload.key].lifeSupportFlg = "0";
  reportState[payload.type].after[payload.key].homeCareFlg = "0";
  return {
    ...reportState
  };
};

/** **********
 * api setter
 *********** */
const fetchDaily = (
  state: ReportState,
  { result }: { result: ReportState }
): ReportState => {
  return {
    ...state,
    performanceDaily: result.performanceDaily,
    reportDaily: result.reportDaily
  };
};

const fetchMonthly = (
  state: ReportState,
  { result }: { result: ReportState }
): ReportState => {
  return {
    ...state,
    reportMonthly: result.reportMonthly
  };
};

const postDaily = (
  state: ReportState,
  { result }: { result: ReportPostDailyState }
): ReportState => {
  const before: Report[] = state.reportDaily.after.map((report) => {
    return { ...report };
  });
  return {
    ...state,
    performanceDaily: {
      ...state.performanceDaily,
      before: { ...result.performanceDaily }
    },
    reportDaily: {
      ...state.reportDaily,
      before
    }
  };
};

const postMonthly = (state: ReportState): ReportState => {
  const before: Report[] = state.reportMonthly.after.map((report) => {
    return { ...report };
  });
  return {
    ...state,
    reportMonthly: {
      ...state.reportMonthly,
      before
    }
  };
};

/** **********
 * setter
 *********** */

const setBeforeToAfterDaily = (state: ReportState): ReportState => {
  const after: Report[] = state.reportDaily.before.map((report) => {
    return { ...report };
  });
  return {
    ...state,
    reportDaily: {
      ...state.reportDaily,
      after
    }
  };
};

const setBeforeToAfterMonthly = (state: ReportState): ReportState => {
  const after: Report[] = state.reportMonthly.before.map((report) => {
    return { ...report };
  });
  return {
    ...state,
    reportMonthly: {
      ...state.reportMonthly,
      after
    }
  };
};

const setBodyRestraintAbolitionUnexecutedFlg = (
  state: ReportState,
  payload: {
    value: ReportPerformanceDaily["bodyRestraintAbolitionUnexecutedFlg"];
    type: ReportTypeInterface["type"];
  }
): ReportState => {
  return {
    ...state,
    performanceDaily: {
      ...state.performanceDaily,
      after: {
        ...state.performanceDaily.after,
        bodyRestraintAbolitionUnexecutedFlg: payload.value
      }
    }
  };
};

const setStatusType = (
  state: ReportState,
  payload: {
    value: Report["statusType"];
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  return changeStatusTypeState(state, payload);
};
const setNightSupportType = (
  state: ReportState,
  payload: {
    value: Report["nightSupportType"];
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  return stateCreate(state, "nightSupportType", payload);
};
const setNightSupportTargetUsersType = (
  state: ReportState,
  payload: {
    value: Report["nightSupportTargetUsers"];
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  return stateCreate(state, "nightSupportTargetUsers", payload);
};
const setHospitalizationSupportType = (
  state: ReportState,
  payload: {
    value: Report["hospitalizationSupportType"];
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  return stateCreate(state, "hospitalizationSupportType", payload);
};
const setGetHomeSupportType = (
  state: ReportState,
  payload: {
    value: Report["getHomeSupportType"];
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  return stateCreate(state, "getHomeSupportType", payload);
};
const setDaytimeSupportType = (
  state: ReportState,
  payload: {
    value: Report["daytimeSupportType"];
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  return stateCreate(state, "daytimeSupportType", payload);
};
const setMedicalSupportType = (
  state: ReportState,
  payload: {
    value: Report["medicalSupportType"];
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  return stateCreate(state, "medicalSupportType", payload);
};
const setLifeSupportFlg = (
  state: ReportState,
  payload: {
    value: Report["lifeSupportFlg"];
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  return stateCreate(state, "lifeSupportFlg", payload);
};
const setMedicalSupportType7 = (
  state: ReportState,
  payload: {
    value: Report["medicalSupportType7Flg"];
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  return stateCreate(state, "medicalSupportType7Flg", payload);
};
const setHomeCareFlg = (
  state: ReportState,
  payload: {
    value: Report["homeCareFlg"];
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  return stateCreate(state, "homeCareFlg", payload);
};
const setRemarks = (
  state: ReportState,
  payload: {
    value: Report["remarks"];
    type: ReportTypeInterface["type"];
    key: number;
  }
): ReportState => {
  return stateCreate(state, "remarks", payload);
};

/**
 * 未退去かつサービス提供状況が未設定の「ユーザー」を対象に、サービス提供の状況と夜間支援を設定する
 * サービス提供の状況 => 1（宿泊）
 * 夜間支援 => 利用者情報で設定したユニットに紐付く夜間支援体制（複数ユニット運営時のみ）
 */
const setAllStatusTypeDaily = (
  state: ReportState,
  payload: Report["statusType"]
): ReportState => {
  const after = state.reportDaily.after.map((report) => {
    if (
      report.isServiceEnd === 1 &&
      (report.statusType === "" || report.statusType === "0")
    ) {
      const statusType = payload;
      const nightSupportType = report.defNightSupportType;
      // 夜間支援がセットされる時、合わせて夜間支援対象者数もセットする
      let nightSupportTargetUsers =
        !!report.defNightSupportType &&
        report.defNightSupportType !== "1" &&
        report.defNightSupportType !== "4"
          ? report.defNightSupportTargetUsers
          : "0";
      // 夜間支援Ⅱの時夜間支援対象者の値が存在するかをチェック
      if (
        report.defNightSupportType === "3" &&
        (nightSupportTargetUsers === "2" || nightSupportTargetUsers === "3")
      ) {
        nightSupportTargetUsers = "0";
      }
      // 医療連携Ⅴを設定
      const medicalSupportType7Flg = report.defMedicalSupportType7Flg;
      return {
        ...report,
        statusType,
        nightSupportType,
        nightSupportTargetUsers,
        medicalSupportType7Flg
      };
    }
    return report;
  });
  return {
    ...state,
    reportDaily: {
      ...state.reportDaily,
      after
    }
  };
};

/**
 * 未退去かつサービス提供状況が未設定の「日付」を対象に、サービス提供の状況と夜間支援を設定する
 * サービス提供の状況 => 1（宿泊）
 * 夜間支援 => 事業所情報で設定した夜間支援体制加算
 */
const setAllStatusTypeMonthly = (
  state: ReportState,
  payload: Report["statusType"]
): ReportState => {
  const after = state.reportMonthly.after.map((report) => {
    if (
      report.isServiceEnd === 1 &&
      (report.statusType === "" || report.statusType === "0")
    ) {
      const statusType = payload;
      const nightSupportType = report.defNightSupportType;
      // 夜間支援がセットされる時、合わせて夜間支援対象者数もセットする
      let nightSupportTargetUsers =
        !!report.defNightSupportType &&
        report.defNightSupportType !== "1" &&
        report.defNightSupportType !== "4"
          ? report.defNightSupportTargetUsers
          : "0";
      // 夜間支援Ⅱの時夜間支援対象者の値が存在するかをチェック
      if (
        report.defNightSupportType === "3" &&
        (nightSupportTargetUsers === "2" || nightSupportTargetUsers === "3")
      ) {
        nightSupportTargetUsers = "0";
      }
      // 医療連携Ⅴを設定
      const medicalSupportType7Flg = report.defMedicalSupportType7Flg;
      return {
        ...report,
        statusType,
        nightSupportType,
        nightSupportTargetUsers,
        medicalSupportType7Flg
      };
    }
    return report;
  });
  return {
    ...state,
    reportMonthly: {
      ...state.reportMonthly,
      after
    }
  };
};

const unsetReport = (): ReportState => {
  return initialState;
};

export default reducerWithInitialState(initialState)
  //  .case(action.fetchDaily.done, fetchDaily)
  .case(action.fetchDaily.done, fetchDaily)
  .case(action.fetchMonthly.done, fetchMonthly)
  .case(
    action.setBodyRestraintAbolitionUnexecutedFlg,
    setBodyRestraintAbolitionUnexecutedFlg
  )
  .case(action.postDaily.done, postDaily)
  .case(action.postMonthly.done, postMonthly)
  .case(action.setBeforeToAfterDaily, setBeforeToAfterDaily)
  .case(action.setBeforeToAfterMonthly, setBeforeToAfterMonthly)
  .case(action.setStatusType, setStatusType)
  .case(action.setNightSupportType, setNightSupportType)
  .case(action.setNightSupportTargetUsersType, setNightSupportTargetUsersType)
  .case(action.setHospitalizationSupportType, setHospitalizationSupportType)
  .case(action.setGetHomeSupportType, setGetHomeSupportType)
  .case(action.setDaytimeSupportType, setDaytimeSupportType)
  .case(action.setMedicalSupportType, setMedicalSupportType)
  .case(action.setMedicalSupportType7, setMedicalSupportType7)
  .case(action.setLifeSupportFlg, setLifeSupportFlg)
  .case(action.setHomeCareFlg, setHomeCareFlg)
  .case(action.setRemarks, setRemarks)
  .case(action.setAllStatusTypeDaily, setAllStatusTypeDaily)
  .case(action.setAllStatusTypeMonthly, setAllStatusTypeMonthly)
  .case(action.unsetReport, unsetReport);
